import APIRequestState from '../_util/api-request';

export default class UserSetPhoneState extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.patch('/user/phone', ...params);
  }
}



// WEBPACK FOOTER //
// ./spa/state/user/user-phone-set.jsx